import { ReactComponent as LockSvg } from '../../resources/images/password.svg';
import { ReactComponent as AccountSvg } from '../../resources/images/username.svg';
import { ReactComponent as EyeSvg } from '../../resources/images/eye.svg';
import { ReactComponent as EyeOffSvg } from '../../resources/images/eye-off.svg';
import { ReactComponent as Logo } from '../../resources/images/logo.svg';
import { ReactComponent as LogoWhite } from '../../resources/images/logo-white.svg';
import { ReactComponent as AlertIcon } from '../../resources/images/alert-triangle.svg';
import Wave from '../../resources/images/wave.svg';
import { withTheme } from '@material-ui/core';
import styled from 'styled-components';
import React from 'react';
import { CURRENT_APP_THEME } from '../../styles/stylesSelector';

const generateAdornmentStyle = ({ theme }, offsetTop) => `
    color: ${theme.palette.primary.dark};
    fill: none;
    height: 1rem;
    ${offsetTop ? 'margin-top: -3px' : ''}
`;

const icons = {
    UsernameIcon: AccountSvg,
    PasswordIcon: LockSvg,
    HidePasswordIcon: EyeOffSvg,
    ShowPasswordIcon: EyeSvg,
    AlertTriangleIcon: AlertIcon,
    LOGIN_ICON_VIEWBOX: '-4 -4 24 24', // Ned icons are 16 x 16, need to place inside a 24x24 adornment
    LogoSvg: Logo,
    LogoWhiteSvg: LogoWhite,
    LogoLabelledBy: 'Ned',
    LoginImageLeft: Wave,
};

// watchman specific icons
const eyeiconsViewBox = '0 0 24 24';

const EyeOff = () => <EyeOffSvg />;
const Eye = () => <EyeSvg viewBox={eyeiconsViewBox} />;

const styledLogo = withTheme(styled(Logo)`
    width: 270px;
    height: 65px;
    transform: translateX(0px);
    margin: auto;
`);

const watchmanicons = {
    LogoSvg: styledLogo,
    UsernameIcon: withTheme(
        styled(AccountSvg)`
            ${theme => generateAdornmentStyle(theme, true)}
        `
    ),
    PasswordIcon: withTheme(
        styled(LockSvg)`
            ${theme => generateAdornmentStyle(theme, true)}
        `
    ),
    HidePasswordIcon: withTheme(
        styled(EyeOff)`
            ${theme => generateAdornmentStyle(theme)}
        `
    ),
    ShowPasswordIcon: withTheme(
        styled(Eye)`
            ${theme => generateAdornmentStyle(theme)}
        `
    ),
    AlertTriangleIcon: withTheme(
        styled(AlertIcon)`
            ${theme => generateAdornmentStyle(theme, true)}
        `
    ),
    LOGIN_ICON_VIEWBOX: '-1 -1 24 24',
    LogoLabelledBy: 'Watchman',
    LoginImageLeft: Wave,
};

export const {
    UsernameIcon,
    PasswordIcon,
    HidePasswordIcon,
    ShowPasswordIcon,
    AlertTriangleIcon,
    LOGIN_ICON_VIEWBOX, // Ned icons are 16 x 16, need to place inside a 24x24 adornment
    LogoSvg,
    LogoLabelledBy,
    LoginImageLeft,
} = {
    ned: icons,
    watchman: watchmanicons,
}[CURRENT_APP_THEME];
